"use strict";

exports.__esModule = true;
exports.CreateReportWizard = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _Form = require("../../Form");
var _Core = require("../../Core");
var _Time = require("../../Time");
var _ReportKindSelector = require("../ReportKindSelector/ReportKindSelector");
var _LayoutTemplate = require("../../LayoutTemplate");
var _API = require("../../API");
var _ReportList = require("../ReportList/ReportList");
var _Widgets = require("../../Widgets");
var _DeviceTagSelector = require("../../Device/DeviceTagSelector");
var _ReportTagContext = require("../ReportTagContext");
var _inputValidation = require("../../../Utils/inputValidation");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var emptyDeviceDetails = {
  id: "",
  name: "Blank Canvas",
  element: _Widgets.DeviceDetailsWidget.createElement({})
};
var emptyReport = {
  id: "",
  name: "Blank Canvas",
  element: _Widgets.ReportWidget.createElement({})
};
var validateReportName = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value, checkIfReportWithProvidedNameExist, translate) {
    var characterError, isReportExist;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(!value || value === null)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, translate("CreateReportWizard.validateName.required", "Name is required."));
        case 1:
          if (!(value && value.length > 35)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, translate("CreateReportWizard.validateName.tooLong", "Name is too long, 35 characters max."));
        case 2:
          // Character rules only -- the 35 character cap above is kept as-is. (VAPT-02)
          characterError = (0, _inputValidation.translateValidationError)((0, _inputValidation.validateNameCharacters)(value), translate);
          if (!characterError) {
            _context.n = 3;
            break;
          }
          return _context.a(2, characterError);
        case 3:
          _context.n = 4;
          return checkIfReportWithProvidedNameExist(value);
        case 4:
          isReportExist = _context.v;
          if (!isReportExist) {
            _context.n = 5;
            break;
          }
          return _context.a(2, translate("CreateReportWizard.validateName.alreadyExist", "Name for the report is already taken"));
        case 5:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function validateReportName(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var StepWrapper = function StepWrapper(_ref2) {
  var reportName = _ref2.reportName,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG,
    style: {
      width: 600,
      minHeight: 470
    }
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: _core.Classes.DIALOG_HEADER
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _core.Classes.DIALOG_HEADER_TITLE
  }, reportName ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateReportWizard.header.title.withName",
    defaultMessage: "New Report: {reportName}",
    values: {
      reportName: reportName
    }
  }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateReportWizard.header.title",
    defaultMessage: "New Report"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY
  }, children), /*#__PURE__*/_react["default"].createElement("footer", {
    className: _core.Classes.DIALOG_FOOTER
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_FOOTER_ACTIONS
  }, /*#__PURE__*/_react["default"].createElement(CreateReportWizard.BackButton, null), /*#__PURE__*/_react["default"].createElement(CreateReportWizard.SubmitButton, {
    lastStepIcon: _icons.IconNames.TICK,
    lastStepText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "CreateReportWizard.finishButton.text",
      defaultMessage: "Next"
    })
  })))));
};

/**
 * A wizard for creating new reports.
 * @component
 */
var CreateReportWizard = exports.CreateReportWizard = (0, _Form.createWizard)({
  steps: [{
    render: function render(_ref3) {
      var checkIfReportWithProvidedNameExist = _ref3.checkIfReportWithProvidedNameExist;
      return /*#__PURE__*/_react["default"].createElement(StepWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref4) {
        var translate = _ref4.translate;
        return /*#__PURE__*/_react["default"].createElement(_ReportTagContext.ReportTagContext.Consumer, null, function (tagContext) {
          if (tagContext && tagContext.loading) {
            return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
          }
          var reportTags = tagContext ? tagContext.data : [];
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
            name: "name",
            validate: (/*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(value) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return validateReportName(value, checkIfReportWithProvidedNameExist, translate);
                    case 1:
                      return _context2.a(2, _context2.v);
                  }
                }, _callee2);
              }));
              return function (_x4) {
                return _ref5.apply(this, arguments);
              };
            }()),
            label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "CreateReportWizard.fields.name.label",
              defaultMessage: "Name"
            }),
            helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "CreateReportWizard.fields.name.helperText",
              defaultMessage: "A descriptive name for the new report."
            }),
            requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
          }, function (_ref6) {
            var input = _ref6.input;
            return (
              /*#__PURE__*/
              // Avoid DebounceInput here: Enter-to-submit races the 300ms
              // debounce under React 18 (Cypress never reaches reportKind step).
              // eslint-disable-next-line jsx-a11y/no-autofocus
              _react["default"].createElement(_core.InputGroup, _extends({
                autoFocus: true,
                maxLength: 35
              }, input))
            );
          }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
            name: "description",
            validate: function validate(value) {
              if (value != null && value.length > 140) {
                return translate("CreateReportWizard.validateDescription.tooLong", "Description is too long, 140 characters max.");
              }
            },
            label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "CreateReportWizard.fields.description.label",
              defaultMessage: "Description"
            }),
            helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "CreateReportWizard.fields.description.helperText",
              defaultMessage: "An optional, short description for the new report"
            })
          }, function (_ref7) {
            var input = _ref7.input;
            return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
              fill: true,
              rows: 4,
              maxLength: 140
            }, input));
          }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
            name: "tags",
            label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "CreateReportWizard.tags",
              defaultMessage: "Tags"
            }),
            helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "CreateReportWizard.fields.tags.helperText",
              defaultMessage: "Separate multiple tags with comma"
            })
          }, function (_ref8) {
            var input = _ref8.input;
            return /*#__PURE__*/_react["default"].createElement(_DeviceTagSelector.DeviceTagSelector, {
              dataTestId: "CreateReportWizard.Tags",
              shouldAddItemWhenNotInList: function shouldAddItemWhenNotInList(value) {
                return !reportTags.find(function (tag) {
                  return tag === value;
                });
              },
              multiple: true,
              items: reportTags,
              onSelect: input.onChange,
              onBlur: input.onBlur,
              selected: input.value || [],
              rightIcon: _icons.IconNames.CARET_DOWN,
              minimal: true
            });
          }));
        });
      }));
    }
  }, {
    render: function render(_ref9) {
      var form = _ref9.form;
      return /*#__PURE__*/_react["default"].createElement(StepWrapper, {
        reportName: form.getState().values.name
      }, /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref0) {
        var translate = _ref0.translate;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
          name: "reportKind",
          validate: function validate(value) {
            if (!value) {
              return translate("CreateReportWizard.validateReportKind.required", "Report kind is required.");
            }
          },
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateReportWizard.fields.reportKind.label",
            defaultMessage: "Report Kind"
          }),
          helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateReportWizard.fields.reportKind.helperText",
            defaultMessage: "The kind of report to create."
          }),
          requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
        }, function (_ref1) {
          var input = _ref1.input;
          return (
            /*#__PURE__*/
            // eslint-disable-next-line jsx-a11y/no-autofocus
            _react["default"].createElement(_ReportKindSelector.ReportKindSelector, _extends({
              autoFocus: true
            }, input))
          );
        }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
          name: "timeRangeKind",
          validate: function validate(value) {
            if (!value) {
              return translate("CreateReportWizard.validateTimeRangeKind.required", "Time range kind is required.");
            }
          },
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateReportWizard.fields.timeRange.label",
            defaultMessage: "Time Range"
          }),
          helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateReportWizard.fields.timeRange.helperText",
            defaultMessage: "The kind of time range to use in this report."
          }),
          requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
        }, function (_ref10) {
          var input = _ref10.input;
          return /*#__PURE__*/_react["default"].createElement(_Time.TimeRangeKindSelector, input);
        }));
      }));
    }
  }, {
    render: function render(_ref11) {
      var form = _ref11.form;
      var _form$getState$values = form.getState().values,
        name = _form$getState$values.name,
        reportKind = _form$getState$values.reportKind;
      var itemPredicate = function itemPredicate(item) {
        if (item.kind !== "EnrichReport" && item.kind !== "EnrichLayoutTemplate") {
          return false;
        }
        return reportKind === "singleDevice" && item.element.type === "DeviceDetails" || reportKind === "multiDevice" && item.element.type === "Report";
      };
      var blankItem = reportKind === "singleDevice" ? emptyDeviceDetails : emptyReport;
      return /*#__PURE__*/_react["default"].createElement(StepWrapper, {
        reportName: name
      }, /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref12) {
        var translate = _ref12.translate;
        return /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
          name: "template",
          validate: function validate(input) {
            if (!input) {
              return translate("CreateReportWizard.validateTemplate.required", "Template is required.");
            }
          },
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateReportWizard.fields.template.label",
            defaultMessage: "Choose Template"
          }),
          helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateReportWizard.fields.template.helperText",
            defaultMessage: "The template to use as a starting point for your new report."
          })
        }, function (_ref13) {
          var input = _ref13.input;
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              height: 400,
              maxHeight: 400,
              overflowY: "auto"
            }
          }, /*#__PURE__*/_react["default"].createElement(_LayoutTemplate.LayoutTemplateCollection, {
            baseURL: "/api/v3/ui-config/dashboards"
          }, function (collection) {
            return /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
              collection: collection
            }, function (collectionProps) {
              return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, collectionProps, function (data) {
                return /*#__PURE__*/_react["default"].createElement(_ReportList.ReportList, {
                  onItemClick: function onItemClick(template) {
                    input.onChange(template);
                  },
                  selectedIds: input.value ? [input.value.id] : undefined,
                  items: [blankItem].concat(data.filter(itemPredicate))
                });
              });
            });
          }));
        });
      }));
    }
  }]
});